import styled from 'styled-components';
import { IDisplayedSlice } from '../../interfaces';
import {
  getSliceColorFromColorConfig,
  IAnalysisColorConfig,
} from '../../utils/analysisColorConfig';
import * as ChartGroupsUI from '../ChartGroups/ChartGroupsUI';

interface IProps {
  slice: IDisplayedSlice;
  colorConfig: IAnalysisColorConfig;
}

const GroupItemIcon = styled(ChartGroupsUI.GroupItemIcon)`
  width: 8px;
  height: 8px;
`;

const CompactChartGroupItemIcon = ({ slice, colorConfig }: IProps) => {
  const sliceColor = getSliceColorFromColorConfig(colorConfig, slice.key);

  return <GroupItemIcon $color={sliceColor} $disabled={!slice.isVisible} />;
};

export default CompactChartGroupItemIcon;
